import React from 'react'
import { Experience } from '../../api/experiences/model'
import { ExperienceCardContent } from './ExperienceCardContent'
import { useBanquetProps } from 'banquet-runtime-modules'

type ExperienceCardProps = {
  experience: Experience
}

export const ExperienceCard = ({ experience }: ExperienceCardProps) => {
  const { featureFlags } = useBanquetProps()

  const hasExperienceImagesFlag = Boolean(
    featureFlags?.['nv1-experience-images']
  )

  const hasExperienceImages =
    hasExperienceImagesFlag && experience.imageConfig?.mobileImageLocation

  if (hasExperienceImages) {
    return (
      <div className='border rounded-[1rem] overflow-hidden '>
        <div className='grid grid-rows-2 xxs:grid-cols-3 xxs:grid-rows-none'>
          <div className='row-span-1 xxs:col-span-1 xxs:row-span-full'>
            <img
              src={experience.imageConfig?.mobileImageLocation}
              alt=''
              className='w-full h-full object-cover'
            />
          </div>
          <div className='p-4 sm:p-6 row-span-2 xxs:col-span-2 xxs:row-span-full'>
            <ExperienceCardContent experience={experience} />
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className='border rounded-[1rem]'>
        <div className='p-4 sm:p-6'>
          <ExperienceCardContent experience={experience} />
        </div>
      </div>
    )
  }
}
